import api from "../../utils/axios";
import { CURRENCY_ENDPOINTS } from "./endpoints";
import { CurrencyList } from "./types";

/**
 * Currencies this deployment knows about, plus whether it runs dual currency.
 *
 * Falls back to a single-currency answer rather than throwing: every caller uses this to decide
 * whether to *offer* a currency choice, and a failed lookup should degrade to today's behaviour
 * rather than break the page.
 */
export const getCurrencyList = async (): Promise<CurrencyList> => {
	try {
		const response = await api.get<CurrencyList>(CURRENCY_ENDPOINTS.list);
		return response.data;
	} catch {
		return {
			countryId: 0,
			dualCurrencyEnabled: false,
			defaultCurrencyId: 0,
			currencies: [],
		};
	}
};
